export const BuildInfo = {timestamp:1784849427000}
